import script from "./PelLoanConfigurationDetailsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PelLoanConfigurationDetailsSection.vue?vue&type=script&setup=true&lang=ts"

import "./PelLoanConfigurationDetailsSection.vue?vue&type=style&index=0&id=894f4e68&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-894f4e68"]])

export default __exports__